// Перша сторона: події пишуться у PostgreSQL (без сторонніх трекерів і cookies).
// Персональні дані дитини в payload не передаються (ТЗ, розділ F).
import { supabase } from './supabase';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'] as const;
const UTM_STORE = 'mz_utm';
const INTENT_STORE = 'mz_intent';
const ANON_STORE = 'mz_anon';

/** Зберігаємо UTM із першого входу на сайт (sessionStorage — лише некритичний UI-стан). */
export function captureUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm: Record<string, string> = {};
    for (const k of UTM_KEYS) { const v = p.get(k); if (v) utm[k] = v.slice(0, 120); }
    if (Object.keys(utm).length) sessionStorage.setItem(UTM_STORE, JSON.stringify(utm));
  } catch { /* ignore */ }
}
/** Намір з рекламного сайту (/start?intent=trial|pay): невідомий або порожній вважається trial (TRL-01). */
export type Intent = 'trial' | 'pay';
export function captureIntent(raw: string | null): Intent {
  const v: Intent = raw === 'pay' ? 'pay' : 'trial';
  try { sessionStorage.setItem(INTENT_STORE, v); } catch { /* ignore */ }
  return v;
}
export function getIntent(): Intent | null {
  try { const v = sessionStorage.getItem(INTENT_STORE); return v === 'pay' || v === 'trial' ? v : null; } catch { return null; }
}
export function getUtm(): Record<string, string> {
  try { return JSON.parse(sessionStorage.getItem(UTM_STORE) || '{}'); } catch { return {}; }
}
function anonId() {
  try {
    let v = sessionStorage.getItem(ANON_STORE);
    if (!v) { v = crypto.randomUUID(); sessionStorage.setItem(ANON_STORE, v); }
    return v;
  } catch { return 'na'; }
}
export type TrackEvent = 'landing_view' | 'cta_click' | 'registration_started'
  | 'start_view' | 'start_cta_click' | 'trial_continue_click' | 'paywall_view';
export function track(event: TrackEvent, payload: Record<string, string> = {}) {
  void supabase.rpc('track_event', { p_event: event, p_payload: { ...getUtm(), ...payload }, p_anon_id: anonId() }).then(() => undefined, () => undefined);
}
export function reportError(source: string, err: unknown, context: Record<string, unknown> = {}) {
  const message = err instanceof Error ? err.message : String(err);
  void supabase.rpc('log_client_error', { p_source: source, p_message: message, p_context: context }).then(() => undefined, () => undefined);
}
